import { GoogleLogin } from '@react-oauth/google';

import type { GoogleAuthKitConfig, UseAuthStore } from '../types';

export function createGoogleLoginButton(useAuthStore: UseAuthStore, config: GoogleAuthKitConfig): React.FC {
  const { api } = config;

  return function GoogleLoginButton() {
    return (
      <GoogleLogin
        onSuccess={async (credentialResponse: { credential?: string }) => {
          const idToken = credentialResponse.credential;
          if (!idToken) {
            useAuthStore.getState().setAuthError('No credential received from Google');
            return;
          }
          try {
            const result = await api.googleAuth(idToken);
            if (result.success && result.user) {
              useAuthStore.getState().handleSignin(result.user, result.accessTokenExp ?? null);
            } else {
              useAuthStore.getState().setAuthError(result.error ?? 'Google sign-in failed');
            }
          } catch (error) {
            const message = error instanceof Error ? error.message : 'Google sign-in failed';
            useAuthStore.getState().setAuthError(message);
          }
        }}
        onError={() => {
          useAuthStore.getState().setAuthError('Google sign-in failed');
        }}
      />
    );
  };
}
